<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
  <circle cx="12" cy="12.996" r="11.5" stroke="#000"/>
  <path stroke="#000" d="M7 9.496h10m-8.5 0l.5 8h6l.5-8m-6-1h5"/>
</svg>
